{
  "bulkActions": {
    "delete": {
      "action": {
        "name_one": "Delete selection ({{ count }})",
        "name_many": "Delete selection ({{ count }})",
        "name_other": "Delete selection ({{ count }})"
      },
      "modal": {
        "cancel": "Cancel",
        "confirm": "Confirm",
        "message": "Do you really want to delete the selected products? This action is irreversible.",
        "title": "Delete"
      },
      "notifications": {
        "error": {
          "message": "An error occurred while deleting the products",
          "title": "Error"
        },
        "success": {
          "message": "Products deleted successfully",
          "title": "Products deleted"
        }
      }
    },
    "hide_one": "hide",
    "hide_other": "hide",
    "import": {
      "actionName": "Import"
    },
    "placeholder": "Product Sheet",
    "show_one": "show",
    "show_other": "show",
    "title": "Actions"
  },
  "components": {
    "columns": {
      "composition": "Composition",
      "mainFabric": "Main Fabric",
      "reference": "Reference"
    }
  },
  "details": {
    "actions": {
      "delete": "Delete"
    },
    "agec": {
      "activity": "{{ activity }}:",
      "metalloplastic": {
        "title": "Metalloplastic materials (%)"
      },
      "microplastics": "Microplastics",
      "na": "Not applicable",
      "primaryPackaging": {
        "primaryPackagingHazardousSubstances": "Hazardous substances",
        "primaryPackagingRecycled": "Recyclable packaging",
        "primaryPackagingRecycledPercentage": "Recycled material (%)",
        "title": "Packaging",
        "withPrimaryPackaging": "Product sold in primary packaging"
      },
      "qrCode": {
        "copied": "Copied!",
        "copyLink": "Copy link",
        "viewProductSheet": "Product sheet"
      },
      "recyclability": {
        "title": "Recycled material (%)",
        "tooltipByCause": {
          "byEnteredComponentsRecycledPercentage": "This value is calculated from the weight and percentage of recycled material collected for each component of the product.",
          "byIngestedMaterialCompositionRecycledPercentage": "This value is calculated from the composition declared at the time of product ingestion. It aggregates the proportions of recycled materials in each component of the product.",
          "byIngestedProductRecycledPercentage": "This value was provided by the organisation in the product ingestion file. It will be updated based on the data collected.",
          "byMixedComponentsRecycledPercentage": "This value aggregates the weight and percentage of recycled material collected for certain components and the proportions of recycled material declared for others.",
          "notCalculated": "The weight of the components and their respective proportion of recycled materials are unavailable and do not allow this percentage to be calculated."
        }
      },
      "title": {
        "other": "Other",
        "qrCode": "QR Code",
        "traceability": "Traceability"
      }
    },
    "composition": {
      "noComponents": "No component yet"
    },
    "customFields": {
      "fieldInfo": "Field information"
    },
    "delete": {
      "cancel": "Cancel",
      "error": {
        "message": "An error occurred while deleting the product",
        "title": "Error"
      },
      "message": "Are you sure you want to delete this product? This action is irreversible and all existing information and document requests will be canceled.",
      "submit": "Delete",
      "success": "Product deleted successfully!"
    },
    "missing": "Missing {{ activity }} country",
    "properties": {
      "address": "Address",
      "collection": "Collection",
      "color": "Color",
      "country": "Country",
      "garment": "Category",
      "item": "Traced item",
      "marketLaunchDate": "Market launch",
      "mass": "Weight",
      "purchaseOrder": "Purchase order",
      "reference": "Reference",
      "supplier": "Supplier"
    },
    "responseVersions": {
      "canonical": "Retained value",
      "empty": "No response history is available for this field yet.",
      "fields": {
        "document": "Document",
        "updatedAt": "Last updated",
        "value": "Value"
      },
      "firstHand": "First hand",
      "onBehalf": "Second hand",
      "open": "View response history",
      "organization": "Responder organization",
      "title": "Response history — {{ field }}",
      "unknownOrganization": "Unknown organization ({{ id }})"
    },
    "sections": {
      "agec": "Environmental quality and characteristics",
      "composition": "Composition",
      "customFields": "Additional information",
      "informations": "Information",
      "suppliers": "Suppliers",
      "traceability": "Traceability chain"
    },
    "suppliers": {
      "noSuppliers": "No registered suppliers yet.",
      "publicTitle_one": "1 localised supplier.",
      "publicTitle_other": "{{ count }} localised suppliers."
    },
    "switch": {
      "hidden": "Private information",
      "visible": "Public information via the search engine"
    },
    "tabs": {
      "general": "Catalog"
    }
  },
  "filters": {
    "search": {
      "placeholder": "Search"
    },
    "title": "Filters"
  },
  "lists": {
    "agecShow": {
      "hidden": "private",
      "visible": "public"
    },
    "analysis": {
      "notifications": {
        "error": {
          "message": "Missing data for {{ analysisNumber }} analyses",
          "title": "Error"
        },
        "success": {
          "message": "{{ analysisNumber }} successful analyses",
          "title": "Success"
        }
      }
    },
    "cells": {
      "agec": {
        "materialPercentage": {
          "computationErrorLabel": "Error",
          "metadataComputationErrorTooltip": "An error occurred while computing this metadata. Please try again later or contact support if the issue persists.",
          "metalloplasticNotCalculatedTooltip": "This metadata requires either the product generic composition, or the finished product weight, component weights, and each component's metalloplastic proportion."
        },
        "nonCompliant": "Non compliant",
        "notApplicable": "Not applicable",
        "step1": "Step 1",
        "step2": "Step 2",
        "tooltips": {
          "notApplicable": "To date, this product is not affected by this regulation.",
          "step1Reached": "Production steps localisation: complete. The transformations targeted by the law are localised.",
          "step1Unreached": "Production steps localisation: missing information. Fill in the countries for the required transformation steps (depending on the product category).",
          "step2Reached": "AGEC data model complete. Step 1 is reached and all required AGEC data (product + components + computed metadata) is present or computable.",
          "step2Unreached": "AGEC data model incomplete. Requires: Step 1 + product data (weight, product composition, per-component composition, packaging info) + component data (weight) + computable metadata (total recycled, synthetic and metalloplastic raw material weights)."
        }
      },
      "traceability": {
        "traceabilityStatus": {
          "active": "Active",
          "error": "Error",
          "pending": "Inactive"
        }
      }
    },
    "certificates": {
      "confidential": "confidential",
      "directSupplier": "Direct Supplier",
      "noAddressProvided": "No address provided"
    },
    "columns": {
      "agecCompliance": "Compliance",
      "agecCountry1": "Step 1",
      "agecCountry2": "Step 2",
      "agecCountry3": "Step 3",
      "agecShow": "Product Sheet",
      "brand": "Brand",
      "collection": "Collection",
      "color": "Color",
      "directSupplier": "Direct Supplier",
      "ingestedAt": "Ingestion",
      "metalloplasticPercentage": "Metalloplastic materials",
      "name": "Name",
      "pendingIrContact": "Information blocker",
      "purchaseOrder": "Purchase order",
      "rank": "Step {{ rank }}",
      "recycledMaterialPercentage": "Recycled materials",
      "reference": "Reference",
      "releaseMicroplastics": "Microplastics",
      "traceabilityLaunchedAt": {
        "label": "Launch",
        "tooltip": "The product traceability trigger date corresponds to the date on which requests are sent to associated business partners"
      },
      "traceabilityStatus": {
        "label": "Traceability",
        "tooltip": "Product traceability status, an active status means the information is currently being collected for the product."
      },
      "type": "Type"
    },
    "export": {
      "all": "Export (CSV)",
      "view": "Export (CSV)"
    },
    "placeholders": {
      "allF": "All",
      "brand": "Brand",
      "collection": "Collection",
      "companies": "Supplier",
      "country": "Country",
      "expired": "In the past",
      "incoming": "Within 3 weeks",
      "ingestionDate": "Ingestion date",
      "launchDate": "Launch date",
      "searchProduct": "Search",
      "standard": "Standard",
      "traceabilityLaunchDate": "Launch",
      "type": "Category"
    },
    "tabs": {
      "certificates": "Standards",
      "customFields": "Additional information",
      "general": "Catalog",
      "traceability": "Traceability"
    },
    "title": "Products"
  },
  "simulation": {
    "notSubscribed": {
      "message": "You have not subscribed to this feature. If you are interested, please contact your account manager or support@traceforgood.com",
      "title": "Unavailable"
    }
  },
  "sorts": {
    "brand": "Brand",
    "brandReference": "Reference",
    "brandType": "Type",
    "collection": "Collection",
    "color": "Color",
    "directSupplier": "Direct supplier",
    "ingestionDate": "Ingestion date",
    "name": "Name",
    "purchaseOrder": "Purchase order",
    "traceabilityLaunchDate": "Traceability launch date",
    "traceabilityStatus": "Traceability status"
  },
  "traceability": {
    "action": {
      "label": "Traceability campaign",
      "tooltip": "Click here to start collecting social & environmental information for the eligible products."
    },
    "itemCard": {
      "documentName": "Document proof has been provided for this field, please click to view",
      "noFieldDef": "No custom field"
    },
    "supplierCard": {
      "address": "Address",
      "company": "Supplier",
      "componentReference": "Component reference",
      "materialReference": "Material reference",
      "productReference": "Product reference"
    }
  }
}
